import { Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/AddOutlined';
import { ToggleButton } from '@mui/material';
import React, { useState } from 'react';
import { useSlate } from 'slate-react';
import { insertEjs } from '../../../transformers/modifyEjs';
import { EjsPlaceholderElement } from '../../../types';

// Local placeholders displayed in preview
export const salutationEjsPlaceholder = '<%- data.salutation %>'; // used in initial state
export const salutationPlaceholder = 'Max Mustermann';
export const salutationLabel = 'Vller Name';

export const lastNameEjsPlaceholder = '<%- data.lastName %>'; // used in initial state
export const lastNamePlaceholder = 'Mustermann';
export const lastNameLabel = 'Nachname';

// EJS placeholders, with local placeholders/vars added in backend
const placeholders = [
	{
		ejs: salutationEjsPlaceholder,
		label: salutationLabel,
		placeholder: salutationPlaceholder,
	},
	{ ejs: '<%- data.firstName %>', label: 'Vorname', placeholder: 'Max' },
	{
		ejs: lastNameEjsPlaceholder,
		label: lastNameLabel,
		placeholder: lastNamePlaceholder,
	},
	{
		ejs: '<%- data.referralCode %>',
		label: 'Empfehlungscode',
		placeholder: 'ABCD1234',
	},
];

// EJS placeholder toggle button
export const EjsPlaceholderButton = () => {
	// Anchor rendered menu to button
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = !!anchorEl;

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const editor = useSlate();
	const handleInsertPlaceholder = (placeholder: EjsPlaceholderElement) => {
		insertEjs(editor, placeholder);
	};

	return (
		<>
			<ToggleButton onClick={handleClick} size='small' value={''}>
				<AddIcon />
			</ToggleButton>
			<Menu
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
			>
				{placeholders.map(({ label, ...placeholder }) => {
					const input: EjsPlaceholderElement = {
						type: 'ejs-placeholder',
						children: [{ text: `{${label}}` }], // Editor placeholder placeholder text
						...placeholder,
					};
					return (
						<MenuItem
							onClick={() => handleInsertPlaceholder(input)}
							key={placeholder.ejs}
						>
							{label}
						</MenuItem>
					);
				})}
			</Menu>
		</>
	);
};
